import React, { useEffect, useState } from "react";
import { Modal } from "../modal";
import BulletinNotificationStyle from "./BulletinNotificationStyle";
import { useSelector } from "react-redux";

export const BulletinNotification = () => {
  const bulletValue = localStorage.getItem("refund-info-262");
  const [isModalOpen, setIsModalOpen] = useState();

  const { companyId } = useSelector(state => state.app.user);

  useEffect(() => {
    if (!bulletValue) {
      localStorage.setItem("refund-info-262", true);
      setIsModalOpen(true);
    }
  }, []);

  const closeModal = () => {
    localStorage.setItem("refund-info-262", false);
    setIsModalOpen(false);
  };

  return (
    <>
      {companyId === 23 && bulletValue === "true" && (
        <Modal closeModal={closeModal}>
          <BulletinNotificationStyle>
            <div className="bulletin-notification">
              <div className="bulletin-notification__header">
                <h3>Benefiti</h3>
              </div>
              <div className="bulletin-notification__body">
                <p> 
                  Obaveštavamo Vas da su{" "}
                  <br /> <br />
                  <b><u>kartice za refundaciju</u></b>{" "}
                  ponovo dostupne {" "}
                  <br/><br/>
                  Uvažavaće se samo računi iz 2026. godine, dok će računi iz 2025. biti odbijeni. {" "}
                </p>
              </div>
            </div>
          </BulletinNotificationStyle>
        </Modal>
      )}
    </>
  );
};
